<template>
  <chart class="qj-echarts" ref="chart" :options="options"></chart>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    located: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultOptions: {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: "65%",
            label: {
              formatter: "{b}\n{c}",
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.8)",
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    options() {
      if (!this.data) return this.defaultOptions;
      return this.renderChart();
    },
    isLocated() {
      return this.located ? "located_" : "not_located_";
    },
  },
  methods: {
    renderChart() {
      let options = { ...this.defaultOptions };
      options.series[0].data = [
        {
          value: this.data[this.isLocated + "valid_cellphones"],
          name: "Celulares",
        },
        {
          value: this.data[this.isLocated + "valid_phones"],
          name: "Fixos",
        },
        {
          value: this.data[this.isLocated + "valid_emails"],
          name: "Emails",
        },
      ];
      return options;
    },
  },
};
</script>

<style></style>
